import { TVehicle, TFinanceCompressed, TFilterFinance } from "types";

import { getValidOffersFromVehicle, getAllRates } from "helper/finance_helper";
import { vehicle } from "fixtures";

interface IFinanceReducer {
  vehicles: TVehicle[];
  filter: any;
}

const FinanceReducer = ({ vehicles, filter }: IFinanceReducer): TVehicle[] => {
  const financeFilter = filter.finance as TFilterFinance | undefined;
  if (!financeFilter) return vehicles;
  const { type, price, customerType } = financeFilter;

  if (type === "buy") {
    const result: TVehicle[] = vehicles
      .filter(({ preis }) => {
        if (!preis) return false;
        const factor = customerType === "private" ? 1 : 1.19;
        return preis / factor >= price[0] && preis / factor <= price[1];
      })
      .map((vehicle: TVehicle) => {
        const allRates = getAllRates(vehicle);
        if (allRates.length === 0) return vehicle;
        const rates = allRates.map((rate) => rate.rate);
        const lowestRate = Math.min(...rates);
        return { ...vehicle, rate: lowestRate };
      });
    return result;
  }

  const calculatedVehicles = vehicles
    .map((vehicle) => {
      const validRates = getValidOffersFromVehicle(
        { ...vehicle },
        financeFilter,
      );

      if (validRates.length === 0) return null;
      const lowestRate = Math.min(...validRates.map((rate) => rate.rate));
      vehicle.rate = lowestRate;
      return vehicle;
    })
    .filter((e) => !!e);

  return calculatedVehicles;
};

export default FinanceReducer;
